// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  rowId: __t.u64().primaryKey().name("row_id"),
  playerId: __t.string().name("player_id"),
  worldId: __t.string().name("world_id"),
  cityId: __t.string().name("city_id"),
  armyId: __t.string().name("army_id"),
  archetype: __t.string(),
  count: __t.u32(),
  ticksRemaining: __t.u32().name("ticks_remaining"),
  status: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
});
